export default __webpack_public_path__ + "static/media/bannerarchywave9.bb2643d5.webp";